import { Location, LocationStrategy } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { List, Map } from 'immutable';
import * as URI from 'urijs';

import {
  ContainedTypeAndId,
  containerKey,
} from '®shared/container-structure/state';
import { FocusService } from '®shared/focus';
import { EditableSection } from '®shared/reading-list/models';

/**
 * Component for a table-of-contents submenu
 */
@Component({
  selector: 'rl-toc-submenu',
  templateUrl: './toc-submenu.component.html',
})
export class TocSubmenuComponent implements OnChanges {
  @Input() currentDepth?: number;
  @Input() maxDepth?: number;
  @Input() sectionIdentifier: ContainedTypeAndId;
  @Input() containerStructure: Map<string, List<ContainedTypeAndId>>;
  @Input() sectionsById: Map<string, EditableSection>;

  section: EditableSection;
  sections: List<ContainedTypeAndId>;

  constructor(
    private focusService: FocusService,
    private location: Location,
    private locationStrategy: LocationStrategy,
  ) {}

  ngOnChanges(changes?: SimpleChanges) {
    if (
      changes &&
      (changes['sectionIdentifier'] ||
        changes['containerStructure'] ||
        changes['sectionsById'])
    ) {
      const { id } = this.sectionIdentifier;

      this.section = this.sectionsById.get(id);

      const children = this.containerStructure.get(
        containerKey(this.sectionIdentifier),
      );
      this.sections = children
        ? children.filter(child => child.type === 'sections')
        : List();
    }
  }

  get sectionUri(): URI {
    return new URI().fragment(this.sectionIdentifier.id);
  }

  get sectionUrl(): string {
    return this.sectionUri.toString();
  }

  onSectionNavigate($event: any) {
    // prevent HREF navigation (but leave HREF for copying)
    if ($event && $event.preventDefault) {
      $event.preventDefault();
    }

    // simulate the browser-native scroll-to-anchor
    this.focusService.scrollToElement(this.sectionIdentifier.id);

    // manually push a state to the history, to change the URL in the browser,
    // but without triggering renavigation and re-routing (thus reloading).
    // This needs us to get a normalised relative URL with the fragment change
    const baseHref = this.locationStrategy.getBaseHref();
    const pathWithBaseHref = this.sectionUri.path();
    const pathWithoutBaseHref =
      baseHref && baseHref !== '/'
        ? pathWithBaseHref.replace(baseHref, '')
        : pathWithBaseHref;

    const relativeUri = this.sectionUri
      .origin('')
      .path(pathWithoutBaseHref)
      .toString();
    this.location.replaceState(relativeUri);
  }
}
